import { ReactNode } from 'react';
import './ListItem.css';

export interface ListItemProps {
  leading?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  meta?: ReactNode;
  badges?: ReactNode;
  trailing?: ReactNode;
  primaryAction?: {
    onClick: () => void;
    ariaLabel?: string;
  };
  onClick?: () => void;
  active?: boolean;
  className?: string;
}

export function ListItem({
  leading,
  title,
  subtitle,
  meta,
  badges,
  trailing,
  primaryAction,
  onClick,
  active = false,
  className = '',
}: ListItemProps) {
  const resolvedOnClick = primaryAction?.onClick ?? onClick;
  const itemClassName = [
    'list-item',
    resolvedOnClick && 'list-item--interactive',
    active && 'list-item--active',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (resolvedOnClick) {
    return (
      <button
        type="button"
        className={itemClassName}
        onClick={resolvedOnClick}
        aria-label={primaryAction?.ariaLabel}
      >
        {leading && <div className="list-item__leading">{leading}</div>}
        <div className="list-item__content">
          <div className="list-item__header">
            <div className="list-item__title">{title}</div>
            {meta && <div className="list-item__meta">{meta}</div>}
          </div>
          {subtitle && <div className="list-item__subtitle">{subtitle}</div>}
          {badges && <div className="list-item__badges">{badges}</div>}
        </div>
        {trailing && <div className="list-item__trailing">{trailing}</div>}
      </button>
    );
  }

  return (
    <div className={itemClassName}>
      {leading && <div className="list-item__leading">{leading}</div>}
      <div className="list-item__content">
        <div className="list-item__header">
          <div className="list-item__title">{title}</div>
          {meta && <div className="list-item__meta">{meta}</div>}
        </div>
        {subtitle && <div className="list-item__subtitle">{subtitle}</div>}
        {badges && <div className="list-item__badges">{badges}</div>}
      </div>
      {trailing && <div className="list-item__trailing">{trailing}</div>}
    </div>
  );
}

export default ListItem;
